// Generated by ReScript, PLEASE EDIT WITH CARE

import * as T from "common/src/T.bs.js";
import * as Curry from "rescript/lib/es6/curry.js";
import * as Modal from "../components/Modal.bs.js";
import * as Share from "../common/Share.bs.js";
import * as Jotai from "jotai";
import * as React from "react";
import * as $$Promise from "common/src/Promise.bs.js";
import * as TbAtoms from "../team-planner-core/TbAtoms.bs.js";
import * as TbUtils13 from "./TbUtils13.bs.js";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as Belt_MapInt from "rescript/lib/es6/belt_MapInt.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as Translation from "common/src/bindings/Translation.bs.js";
import * as ContentSection from "common/src/ContentSection.bs.js";
import * as SnackbarService from "common/src/SnackbarService.bs.js";
import CopyToClipboard from "copy-to-clipboard";
import Button from "@mui/material/Button";
import Switch from "@mui/material/Switch";
import TextField from "@mui/material/TextField";
import Clear from "@mui/icons-material/Clear";
import CameraAlt from "@mui/icons-material/CameraAlt";
import UnfoldLess from "@mui/icons-material/UnfoldLess";
import UnfoldMore from "@mui/icons-material/UnfoldMore";
import FormControlLabel from "@mui/material/FormControlLabel";
import ContentCopy from "@mui/icons-material/ContentCopy";
import ContentPaste from "@mui/icons-material/ContentPaste";

function TbConfig13(Props) {
  var locale = Props.locale;
  var extended = Props.extended;
  var setExpanded = Props.setExpanded;
  var units = Props.units;
  var setUnits = Props.setUnits;
  var useSkins = Props.useSkins;
  var setUseSkins = Props.setUseSkins;
  var showNames = Props.showNames;
  var setShowNames = Props.setShowNames;
  var onGoToSet6 = Props.onGoToSet6;
  var augments = Props.augments;
  var onScreenshot = Props.onScreenshot;
  var gameCfg = Props.gameCfg;
  var t = Translation.useT(/* Common */0);
  var match = Jotai.useAtom(TbAtoms.disableTooltips);
  var setDisableTooltips = match[1];
  var match$1 = Jotai.useAtom(TbAtoms.compactMode);
  var setCompactMode = match$1[1];
  var match$2 = React.useState(function () {
        return false;
      });
  var setImportModalOpen = match$2[1];
  var match$3 = React.useState(function () {
        return "";
      });
  var setImportCode = match$3[1];
  var importCode = match$3[0];
  return React.createElement("div", {
              className: "flex flex-col justify-between h-full"
            }, React.createElement(ContentSection.make, {
                  className: "w-full md:w-auto",
                  children: null
                }, React.createElement("div", {
                      className: "text-sm pb-4 block md:hidden"
                    }, "Tap a unit on board to mark it as 3-star."), React.createElement("div", {
                      className: "text-sm pb-4 hidden md:block xl:hidden"
                    }, t("Right click a unit on board to mark is as 3-star.")), React.createElement("div", {
                      className: "flex flex-col md:flex-row items-center "
                    }, React.createElement("div", {
                          className: "flex md:flex-col pr-8"
                        }, React.createElement("div", undefined, React.createElement(Button, {
                                  onClick: (function (param) {
                                      
                                    }),
                                  variant: "contained",
                                  color: "secondary",
                                  size: "small",
                                  children: t("Set") + " 13"
                                })), React.createElement("div", {
                              className: "pl-4 md:pl-0 md:pt-2"
                            }, React.createElement(Button, {
                                  onClick: (function (param) {
                                      return Curry._1(onGoToSet6, undefined);
                                    }),
                                  variant: "text",
                                  color: "primary",
                                  size: "small",
                                  children: t("Set") + "4.5"
                                }))), React.createElement("div", {
                          className: "text-sm hidden xl:block max-w-[200px] xl:pr-8"
                        }, t("Right click a unit on board to mark it as 3-star.")), React.createElement("div", {
                          className: "pt-3 md:pt-0 flex flex-row items-center md:flex-row"
                        }, React.createElement("div", {
                              className: "flex flex-col gap-2"
                            }, React.createElement(Share.Button.make, {
                                  forceFull: true,
                                  url: "https://tactics.tools/" + (
                                    locale === "en" ? "" : locale + "/"
                                  ) + "team-builder/" + TbUtils13.encodeQs(units, augments, gameCfg),
                                  className: "w-full"
                                }), React.createElement(Button, {
                                  startIcon: React.createElement(ContentCopy, {}),
                                  onClick: (function (param) {
                                      var code = TbUtils13.genCode(Belt_Array.keepMap(Belt_MapInt.toArray(units), (function (param) {
                                                  var unitId = param[1].unit;
                                                  if (unitId.TAG === /* Unit */0) {
                                                    return unitId._0;
                                                  }
                                                  
                                                })));
                                      CopyToClipboard(code);
                                      var cb = SnackbarService.sub.contents;
                                      if (cb !== undefined) {
                                        return Curry._1(cb, "Team planner code copied to clipboard");
                                      }
                                      
                                    }),
                                  variant: "contained",
                                  color: "secondary",
                                  size: "small",
                                  children: t("Copy code")
                                })), React.createElement("div", {
                              className: "flex flex-col items-stretch w-[210px] px-8"
                            }, React.createElement("div", undefined, React.createElement(Button, {
                                      classes: {
                                        root: "w-full"
                                      },
                                      startIcon: React.createElement(Clear, {}),
                                      onClick: (function (param) {
                                          return Curry._1(setUnits, (function (param) {
                                                        
                                                      }));
                                        }),
                                      variant: "outlined",
                                      color: "primary",
                                      size: "small",
                                      children: t("Clear Board")
                                    })), React.createElement("div", {
                                  className: "pt-2"
                                }, React.createElement(Button, {
                                      classes: {
                                        root: "w-full"
                                      },
                                      startIcon: extended ? React.createElement(UnfoldLess, {}) : React.createElement(UnfoldMore, {}),
                                      onClick: (function (param) {
                                          return Curry._1(setExpanded, (function (x) {
                                                        return !x;
                                                      }));
                                        }),
                                      variant: "outlined",
                                      color: "primary",
                                      size: "small",
                                      children: extended ? t("Player Board") : t("Full Board")
                                    })))), React.createElement("div", {
                          className: "pt-3 md:pt-0 md:pl-6 flex flex-row"
                        }, React.createElement("div", undefined, React.createElement("div", undefined, React.createElement(FormControlLabel, {
                                      control: React.createElement(Switch, {
                                            checked: useSkins,
                                            onChange: (function (e) {
                                                return Curry._1(setUseSkins, e.target.checked);
                                              }),
                                            size: "small"
                                          }),
                                      label: t("Use Skins")
                                    })), React.createElement("div", {
                                  className: "pt-2"
                                }, React.createElement(FormControlLabel, {
                                      control: React.createElement(Switch, {
                                            checked: showNames,
                                            onChange: (function (e) {
                                                return Curry._1(setShowNames, e.target.checked);
                                              }),
                                            size: "small"
                                          }),
                                      label: t("Show Names")
                                    }))), React.createElement("div", {
                              className: "pl-3"
                            }, React.createElement("div", undefined, React.createElement(FormControlLabel, {
                                      control: React.createElement(Switch, {
                                            checked: !match[0],
                                            onChange: (function (e) {
                                                var v = e.target.checked;
                                                return Curry._1(setDisableTooltips, !v);
                                              }),
                                            size: "small"
                                          }),
                                      label: t("Mouse Hover Info")
                                    })), React.createElement("div", {
                                  className: "pt-2"
                                }, React.createElement(FormControlLabel, {
                                      control: React.createElement(Switch, {
                                            checked: match$1[0],
                                            onChange: (function (e) {
                                                return Curry._1(setCompactMode, e.target.checked);
                                              }),
                                            size: "small"
                                          }),
                                      label: t("Positioning Mode")
                                    })))), React.createElement("div", {
                          className: "pt-4 md:pt-0 pl-2 flex md:flex-col gap-2"
                        }, React.createElement(Button, {
                              startIcon: React.createElement(CameraAlt, {
                                    fontSize: "small"
                                  }),
                              onClick: (function (param) {
                                  return Curry._1(onScreenshot, undefined);
                                }),
                              variant: "outlined",
                              color: "primary",
                              size: "small",
                              children: t("Screenshot")
                            }), React.createElement(Button, {
                              startIcon: React.createElement(ContentPaste, {}),
                              onClick: (function (param) {
                                  var timeout = setTimeout((function (param) {
                                          return Curry._1(setImportModalOpen, (function (param) {
                                                        return true;
                                                      }));
                                        }), 50);
                                  return $$Promise.consume(T.clipboardText(undefined), (function (text) {
                                                var board = TbUtils13.boardFromCode(text);
                                                if (board === undefined) {
                                                  return ;
                                                }
                                                var board$1 = Caml_option.valFromOption(board);
                                                Curry._1(setUnits, (function (param) {
                                                        return board$1;
                                                      }));
                                                clearTimeout(timeout);
                                                Curry._1(setImportModalOpen, (function (param) {
                                                        return false;
                                                      }));
                                                return SnackbarService.sendMsg("Board imported");
                                              }));
                                }),
                              variant: "contained",
                              color: "secondary",
                              size: "small",
                              children: t("Import Code")
                            })))), React.createElement(Modal.make, {
                  modalOpen: match$2[0],
                  setModalOpen: setImportModalOpen,
                  children: React.createElement("div", {
                        className: "flex items-center gap-2 p-4"
                      }, React.createElement(TextField, {
                            classes: {
                              root: "w-[300px]"
                            },
                            placeholder: "Code",
                            value: importCode,
                            onChange: (function (ev) {
                                var board = TbUtils13.boardFromCode(ev.target.value);
                                if (board === undefined) {
                                  return Curry._1(setImportCode, ev.target.value);
                                }
                                var board$1 = Caml_option.valFromOption(board);
                                Curry._1(setUnits, (function (param) {
                                        return board$1;
                                      }));
                                Curry._1(setImportModalOpen, (function (param) {
                                        return false;
                                      }));
                                return SnackbarService.sendMsg("Board imported");
                              }),
                            variant: "standard"
                          }), React.createElement(Button, {
                            onClick: (function (param) {
                                var board = TbUtils13.boardFromCode(importCode);
                                if (board === undefined) {
                                  return SnackbarService.sendMsg("Invalid code");
                                }
                                var board$1 = Caml_option.valFromOption(board);
                                Curry._1(setUnits, (function (param) {
                                        return board$1;
                                      }));
                                Curry._1(setImportModalOpen, (function (param) {
                                        return false;
                                      }));
                                return SnackbarService.sendMsg("Board imported");
                              }),
                            variant: "outlined",
                            children: "Import"
                          }))
                }));
}

var make = React.memo(TbConfig13);

export {
  make ,
  
}
/* make Not a pure module */
